import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "#trapezoid-left-svg {\n  width: 82px;\n  height: 28px;\n  fill: #e62e2e;\n  fill-opacity: 0.048;\n}\n";
styleInject(css_248z);

export { css_248z as default };
